import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

// AuditLayout — the shell for the Audit workflow (approved IA §5): reconcile warehouse reality
// against Season Manager's approved baseline. It owns the section header, the child navigation and
// page framing; the feature components rendered through <Outlet /> own their grids, editing,
// dialogs, data loading and API calls.
//
// Season Audit is the group's INDEX route (`/audit`), so it is the default landing and is reachable
// with no extra click when Audit becomes a group. Class Audit is a sibling. New entity audits slot
// in here as additional tabs without touching the features.
export default function AuditLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = location.pathname.includes("/audit/rule-management") ? "rules"
    : location.pathname.includes("/audit/coach-checkin-audit") ? "coach"
      : location.pathname.includes("/audit/class-audit") ? "class"
        : "season";
  const handleChange = (event, next) => {
    navigate(next === "class" ? "/audit/class-audit"
      : next === "coach" ? "/audit/coach-checkin-audit"
        : next === "rules" ? "/audit/rule-management"
          : "/audit");
  };

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Box sx={{ mt: 1, mb: 0.5 }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Audit
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Reconcile warehouse reality against approved metadata.
        </Typography>
      </Box>

      <Tabs
        value={activeTab}
        onChange={handleChange}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}
      >
        <Tab label="Season Audit" value="season" />
        <Tab label="Class Audit" value="class" />
        <Tab label="Coach Check-In Audit" value="coach" />
        <Tab label="Rule Management" value="rules" />
      </Tabs>

      <Outlet />
    </Box>
  );
}
